import React, { useState } from "react";
import "./ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    country: "",
    position: "",
    usage: "",
    requirements: "",
    privacy: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    // Add backend/API integration here
  };

  return (
    <div className="contactus-container">
      <h1 className="contactus-heading">Contact Us</h1>
      <p>
        If you require multiple assessments for various products or countries,
        please contact us to discuss a customized subscription plan. We would
        be delighted to schedule a call to address your specific needs and
        requirements.
      </p>
      <form className="contactus-form" onSubmit={handleSubmit}>
        <label htmlFor="name">Name</label>
        <input
          type="text"
          id="name"
          name="name"
          placeholder="Enter your name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label htmlFor="email">Email Address</label>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Enter your email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label htmlFor="phone">Phone Number</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          placeholder="Enter your phone number"
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <label htmlFor="company">Company Name</label>
        <input
          type="text"
          id="company"
          name="company"
          placeholder="Enter your company name"
          value={formData.company}
          onChange={handleChange}
          required
        />

        <label htmlFor="country">Country</label>
        <select
          id="country"
          name="country"
          value={formData.country}
          onChange={handleChange}
          required
        >
          <option value="" disabled>
            Select your country
          </option>
          <option value="US">United States</option>
          <option value="IN">India</option>
          <option value="UK">United Kingdom</option>
          <option value="CA">Canada</option>
          <option value="AU">Australia</option>
        </select>

        <label htmlFor="position">Your Position</label>
        <input
          type="text"
          id="position"
          name="position"
          placeholder="Enter your position"
          value={formData.position}
          onChange={handleChange}
          required
        />

        <label htmlFor="usage">Estimated Number of Uses</label>
        <select
          id="usage"
          name="usage"
          value={formData.usage}
          onChange={handleChange}
          required
        >
          <option value="" disabled>
            Select an option
          </option>
          <option value="3-5">3-5 uses per year</option>
          <option value="5-9">5-9 uses per year</option>
          <option value="10+">10+ uses per year</option>
        </select>

        <label htmlFor="requirements">Other Requirements</label>
        <textarea
          id="requirements"
          name="requirements"
          rows="4"
          placeholder="e.g., multiple users, unlimited access, customizations, etc."
          value={formData.requirements}
          onChange={handleChange}
        ></textarea>

        <div>
          <label>
            <input
              type="checkbox"
              name="privacy"
              checked={formData.privacy}
              onChange={handleChange}
              required
            />
            By clicking on Schedule a Call, you acknowledge having read our
            Privacy Notice.
          </label>
        </div>

        <button type="submit" className="contactus-button">
          Schedule a Call
        </button>
      </form>
    </div>
  );
};

export default ContactUs;
